// Переводы раздела «Заявки» (обращения в поддержку). Подмешиваются в ресурсы i18next в i18next.config.js
// через withSupportTranslations — только для языков, которые есть у сайта.

const ru = {
  support_nav: "Поддержка",
  support_title: "Мои заявки",
  support_subtitle: "Вопросы по заказам и сервису — ответ придёт сюда и на email",
  support_footer_link: "Поддержка",
  support_write: "Написать в поддержку",
  support_write_short: "Поддержка",
  support_new_ticket: "Новая заявка",
  support_filter_open: "Открытые",
  support_filter_all: "Все",
  support_status_new: "Новая",
  support_status_in_progress: "В работе",
  support_status_waiting_customer: "Ждём вашего ответа",
  support_status_closed: "Закрыта",
  support_ticket_number: "Заявка №{{number}}",
  support_unread_count: "Новых ответов: {{count}}",
  support_no_tickets: "Заявок пока нет",
  support_no_open_tickets: "Открытых заявок нет",
  support_load_more: "Показать ещё",
  support_order: "Заказ",
  support_order_optional: "Заказ (необязательно)",
  support_order_none: "Без заказа — общий вопрос",
  support_order_manual: "Ввести номер заказа",
  support_order_number: "Номер заказа",
  support_enter_order_number: "Например, 123456",
  support_subject: "Тема",
  support_subject_placeholder: "Кратко опишите вопрос",
  support_category: "Категория",
  support_category_choose: "Выберите категорию",
  support_service_type: "Услуга",
  support_service_avia: "Авиабилеты",
  support_service_general: "Общий вопрос",
  support_service_hotel: "Отели",
  support_category_refund: "Возврат",
  support_category_exchange: "Обмен",
  support_category_passenger_data: "Данные пассажиров",
  support_category_baggage: "Багаж",
  support_category_seats: "Места в самолёте",
  support_category_schedule_change: "Изменение расписания",
  support_category_payment: "Оплата",
  support_category_documents: "Документы",
  support_category_account: "Личный кабинет",
  support_category_other: "Другое",
  support_message: "Сообщение",
  support_message_placeholder: "Опишите ситуацию подробно",
  support_reply_placeholder: "Ваш ответ…",
  support_files_add: "Прикрепить файлы",
  support_files_hint: "До {{count}} файлов, до {{size}} МБ каждый: {{ext}}",
  support_file_too_many: "Можно прикрепить не больше {{count}} файлов",
  support_file_too_large: "Файл «{{name}}» больше {{size}} МБ",
  support_file_bad_format: "Формат файла «{{name}}» не поддерживается",
  support_text_too_long: "Слишком длинный текст: максимум {{max}} символов",
  support_remove: "Убрать",
  support_send: "Отправить",
  support_create: "Создать заявку",
  support_cancel: "Отмена",
  support_back_to_list: "Все заявки",
  support_close: "Закрыть заявку",
  support_reopen: "Переоткрыть",
  support_close_confirm: "Закрыть заявку? При необходимости её можно будет переоткрыть.",
  support_closed_banner: "Заявка закрыта. Если вопрос не решён — переоткройте её.",
  support_closed_banner_no_reopen: "Заявка закрыта. Если остались вопросы — создайте новую заявку.",
  support_waiting_banner: "Поддержка ждёт вашего ответа",
  support_author_staff: "Поддержка",
  support_author_you: "Вы",
  support_event_created: "Заявка создана",
  support_event_status: "Статус: {{from}} → {{to}}",
  support_created_at: "Создана",
  support_updated_at: "Обновлена",
  support_messages_count: "Сообщений: {{count}}",
  support_download: "Скачать",
  support_login_required: "Войдите в личный кабинет, чтобы открыть заявку",
  support_login: "Войти",
  support_access_title: "Найти мой заказ",
  support_access_subtitle: "Чтобы написать в поддержку без входа в кабинет, подтвердите, что заказ ваш.",
  support_access_hint: "При бронировании мы регистрируем вас по email — код придёт туда.",
  support_access_email: "Email, указанный при бронировании",
  support_access_send_code: "Получить код",
  support_code_sent: "Мы отправили письмо с кодом на {{email}}",
  support_code_label: "Код из письма",
  support_code_placeholder: "6 цифр",
  support_code_confirm: "Подтвердить",
  support_code_resend: "Отправить код ещё раз",
  support_code_resend_in: "Отправить ещё раз через {{seconds}} с",
  support_change_order: "Другой заказ",
  support_have_account: "Есть личный кабинет?",
  support_guest_order: "Заявки по заказу {{order}}",
  support_guest_exit: "Выйти",
  support_verifying: "Проверяем ссылку…",
  support_error_default: "Не удалось выполнить запрос. Попробуйте ещё раз.",
  support_error_ticket_not_found: "Заявка не найдена или у вас нет к ней доступа.",
  support_error_validation: "Проверьте заполнение полей.",
  support_error_validation_fields: "Проверьте поля: {{fields}}",
  support_error_ticket_closed: "Заявка закрыта — переоткройте её, чтобы написать.",
  support_error_rate_limited: "Слишком много запросов. Попробуйте через минуту.",
  support_error_file_invalid: "Файл не принят.",
  support_error_too_many_files: "Слишком много файлов в одном сообщении.",
  support_error_file_too_large: "Файл слишком большой.",
  support_error_file_format: "Этот формат файла не поддерживается.",
  support_error_file_upload: "Не удалось загрузить файл. Попробуйте ещё раз.",
  support_error_order_not_found: "Заказ не найден.",
  support_error_action_not_allowed: "Это действие сейчас недоступно.",
  support_error_reopen_expired: "Срок, в который можно переоткрыть заявку, истёк — создайте новую.",
  support_error_order_not_exist: "Заказ с таким номером и email не найден.",
  support_error_email_send: "Не удалось отправить письмо. Попробуйте позже.",
  support_error_too_many_requests: "Слишком много попыток. Подождите немного и повторите.",
  support_error_unavailable: "Поддержка временно недоступна. Попробуйте позже.",
  support_error_code_invalid: "Неверный или просроченный код.",
  support_error_access_required: "Нужно подтвердить доступ: войдите в кабинет или запросите код по заказу.",
};

const en = {
  support_nav: "Support",
  support_title: "My requests",
  support_subtitle: "Questions about orders and our service — replies come here and to your email",
  support_footer_link: "Support",
  support_write: "Contact support",
  support_write_short: "Support",
  support_new_ticket: "New request",
  support_filter_open: "Open",
  support_filter_all: "All",
  support_status_new: "New",
  support_status_in_progress: "In progress",
  support_status_waiting_customer: "Waiting for your reply",
  support_status_closed: "Closed",
  support_ticket_number: "Request #{{number}}",
  support_unread_count: "New replies: {{count}}",
  support_no_tickets: "No requests yet",
  support_no_open_tickets: "No open requests",
  support_load_more: "Show more",
  support_order: "Order",
  support_order_optional: "Order (optional)",
  support_order_none: "No order — general question",
  support_order_manual: "Enter order number",
  support_order_number: "Order number",
  support_enter_order_number: "For example, 123456",
  support_subject: "Subject",
  support_subject_placeholder: "Briefly describe your question",
  support_category: "Category",
  support_category_choose: "Choose a category",
  support_service_type: "Service",
  support_service_avia: "Flights",
  support_service_general: "General question",
  support_service_hotel: "Hotels",
  support_category_refund: "Refund",
  support_category_exchange: "Exchange",
  support_category_passenger_data: "Passenger details",
  support_category_baggage: "Baggage",
  support_category_seats: "Seats",
  support_category_schedule_change: "Schedule change",
  support_category_payment: "Payment",
  support_category_documents: "Documents",
  support_category_account: "Account",
  support_category_other: "Other",
  support_message: "Message",
  support_message_placeholder: "Describe the situation in detail",
  support_reply_placeholder: "Your reply…",
  support_files_add: "Attach files",
  support_files_hint: "Up to {{count}} files, up to {{size}} MB each: {{ext}}",
  support_file_too_many: "You can attach no more than {{count}} files",
  support_file_too_large: "File “{{name}}” is larger than {{size}} MB",
  support_file_bad_format: "File format of “{{name}}” is not supported",
  support_text_too_long: "Text is too long: {{max}} characters maximum",
  support_remove: "Remove",
  support_send: "Send",
  support_create: "Create request",
  support_cancel: "Cancel",
  support_back_to_list: "All requests",
  support_close: "Close request",
  support_reopen: "Reopen",
  support_close_confirm: "Close this request? You can reopen it later if needed.",
  support_closed_banner: "The request is closed. If your issue is not resolved, reopen it.",
  support_closed_banner_no_reopen: "The request is closed. If you have more questions, create a new request.",
  support_waiting_banner: "Support is waiting for your reply",
  support_author_staff: "Support",
  support_author_you: "You",
  support_event_created: "Request created",
  support_event_status: "Status: {{from}} → {{to}}",
  support_created_at: "Created",
  support_updated_at: "Updated",
  support_messages_count: "Messages: {{count}}",
  support_download: "Download",
  support_login_required: "Log in to your account to open the request",
  support_login: "Log in",
  support_access_title: "Find my order",
  support_access_subtitle: "To contact support without logging in, confirm that the order is yours.",
  support_access_hint: "When you book, we register you by email — the code will be sent there.",
  support_access_email: "Email used for the booking",
  support_access_send_code: "Get code",
  support_code_sent: "We have sent an email with a code to {{email}}",
  support_code_label: "Code from the email",
  support_code_placeholder: "6 digits",
  support_code_confirm: "Confirm",
  support_code_resend: "Send the code again",
  support_code_resend_in: "Resend in {{seconds}} s",
  support_change_order: "Another order",
  support_have_account: "Have an account?",
  support_guest_order: "Requests for order {{order}}",
  support_guest_exit: "Exit",
  support_verifying: "Checking the link…",
  support_error_default: "The request failed. Please try again.",
  support_error_ticket_not_found: "The request was not found or you have no access to it.",
  support_error_validation: "Please check the form fields.",
  support_error_validation_fields: "Please check: {{fields}}",
  support_error_ticket_closed: "The request is closed — reopen it to write.",
  support_error_rate_limited: "Too many requests. Please try again in a minute.",
  support_error_file_invalid: "The file was not accepted.",
  support_error_too_many_files: "Too many files in one message.",
  support_error_file_too_large: "The file is too large.",
  support_error_file_format: "This file format is not supported.",
  support_error_file_upload: "Failed to upload the file. Please try again.",
  support_error_order_not_found: "Order not found.",
  support_error_action_not_allowed: "This action is not available now.",
  support_error_reopen_expired: "The request can no longer be reopened — please create a new one.",
  support_error_order_not_exist: "No order found with this number and email.",
  support_error_email_send: "Failed to send the email. Please try later.",
  support_error_too_many_requests: "Too many attempts. Please wait a little and try again.",
  support_error_unavailable: "Support is temporarily unavailable. Please try later.",
  support_error_code_invalid: "Invalid or expired code.",
  support_error_access_required: "Access confirmation required: log in or request a code for your order.",
};

const uz = {
  support_nav: "Yordam",
  support_title: "Mening murojaatlarim",
  support_subtitle: "Buyurtmalar va xizmat bo‘yicha savollar — javob shu yerga va email’ingizga keladi",
  support_footer_link: "Yordam xizmati",
  support_write: "Yordam xizmatiga yozish",
  support_write_short: "Yordam",
  support_new_ticket: "Yangi murojaat",
  support_filter_open: "Ochiq",
  support_filter_all: "Barchasi",
  support_status_new: "Yangi",
  support_status_in_progress: "Ko‘rib chiqilmoqda",
  support_status_waiting_customer: "Javobingizni kutyapmiz",
  support_status_closed: "Yopilgan",
  support_ticket_number: "Murojaat №{{number}}",
  support_unread_count: "Yangi javoblar: {{count}}",
  support_no_tickets: "Hozircha murojaatlar yo‘q",
  support_no_open_tickets: "Ochiq murojaatlar yo‘q",
  support_load_more: "Yana ko‘rsatish",
  support_order: "Buyurtma",
  support_order_optional: "Buyurtma (ixtiyoriy)",
  support_order_none: "Buyurtmasiz — umumiy savol",
  support_order_manual: "Buyurtma raqamini kiritish",
  support_order_number: "Buyurtma raqami",
  support_enter_order_number: "Masalan, 123456",
  support_subject: "Mavzu",
  support_subject_placeholder: "Savolingizni qisqacha yozing",
  support_category: "Toifa",
  support_category_choose: "Toifani tanlang",
  support_service_type: "Xizmat",
  support_service_avia: "Aviachiptalar",
  support_service_general: "Umumiy savol",
  support_service_hotel: "Mehmonxonalar",
  support_category_refund: "Qaytarish",
  support_category_exchange: "Almashtirish",
  support_category_passenger_data: "Yo‘lovchi ma’lumotlari",
  support_category_baggage: "Bagaj",
  support_category_seats: "Samolyotdagi o‘rinlar",
  support_category_schedule_change: "Jadval o‘zgarishi",
  support_category_payment: "To‘lov",
  support_category_documents: "Hujjatlar",
  support_category_account: "Shaxsiy kabinet",
  support_category_other: "Boshqa",
  support_message: "Xabar",
  support_message_placeholder: "Vaziyatni batafsil yozing",
  support_reply_placeholder: "Javobingiz…",
  support_files_add: "Fayl biriktirish",
  support_files_hint: "{{count}} tagacha fayl, har biri {{size}} MB gacha: {{ext}}",
  support_file_too_many: "{{count}} tadan ortiq fayl biriktirib bo‘lmaydi",
  support_file_too_large: "«{{name}}» fayli {{size}} MB dan katta",
  support_file_bad_format: "«{{name}}» fayl formati qo‘llab-quvvatlanmaydi",
  support_text_too_long: "Matn juda uzun: ko‘pi bilan {{max}} belgi",
  support_remove: "Olib tashlash",
  support_send: "Yuborish",
  support_create: "Murojaat yaratish",
  support_cancel: "Bekor qilish",
  support_back_to_list: "Barcha murojaatlar",
  support_close: "Murojaatni yopish",
  support_reopen: "Qayta ochish",
  support_close_confirm: "Murojaat yopilsinmi? Kerak bo‘lsa, uni qayta ochish mumkin.",
  support_closed_banner: "Murojaat yopilgan. Agar muammo hal bo‘lmagan bo‘lsa, uni qayta oching.",
  support_closed_banner_no_reopen: "Murojaat yopilgan. Savollaringiz qolgan bo‘lsa, yangi murojaat yarating.",
  support_waiting_banner: "Yordam xizmati javobingizni kutmoqda",
  support_author_staff: "Yordam xizmati",
  support_author_you: "Siz",
  support_event_created: "Murojaat yaratildi",
  support_event_status: "Holat: {{from}} → {{to}}",
  support_created_at: "Yaratilgan",
  support_updated_at: "Yangilangan",
  support_messages_count: "Xabarlar: {{count}}",
  support_download: "Yuklab olish",
  support_login_required: "Murojaatni ochish uchun shaxsiy kabinetga kiring",
  support_login: "Kirish",
  support_access_title: "Buyurtmamni topish",
  support_access_subtitle: "Kabinetga kirmasdan yordam xizmatiga yozish uchun buyurtma sizniki ekanini tasdiqlang.",
  support_access_hint: "Bron qilishda biz sizni email orqali ro‘yxatdan o‘tkazamiz — kod o‘sha manzilga keladi.",
  support_access_email: "Bron qilishda ko‘rsatilgan email",
  support_access_send_code: "Kodni olish",
  support_code_sent: "Kod yozilgan xatni {{email}} manziliga yubordik",
  support_code_label: "Xatdagi kod",
  support_code_placeholder: "6 ta raqam",
  support_code_confirm: "Tasdiqlash",
  support_code_resend: "Kodni qayta yuborish",
  support_code_resend_in: "{{seconds}} soniyadan keyin qayta yuborish",
  support_change_order: "Boshqa buyurtma",
  support_have_account: "Shaxsiy kabinetingiz bormi?",
  support_guest_order: "{{order}} buyurtmasi bo‘yicha murojaatlar",
  support_guest_exit: "Chiqish",
  support_verifying: "Havola tekshirilmoqda…",
  support_error_default: "So‘rovni bajarib bo‘lmadi. Qayta urinib ko‘ring.",
  support_error_ticket_not_found: "Murojaat topilmadi yoki unga kirish huquqingiz yo‘q.",
  support_error_validation: "Maydonlar to‘g‘ri to‘ldirilganini tekshiring.",
  support_error_validation_fields: "Tekshiring: {{fields}}",
  support_error_ticket_closed: "Murojaat yopilgan — yozish uchun uni qayta oching.",
  support_error_rate_limited: "So‘rovlar juda ko‘p. Bir daqiqadan so‘ng urinib ko‘ring.",
  support_error_file_invalid: "Fayl qabul qilinmadi.",
  support_error_too_many_files: "Bitta xabarda fayllar juda ko‘p.",
  support_error_file_too_large: "Fayl juda katta.",
  support_error_file_format: "Bu fayl formati qo‘llab-quvvatlanmaydi.",
  support_error_file_upload: "Faylni yuklab bo‘lmadi. Qayta urinib ko‘ring.",
  support_error_order_not_found: "Buyurtma topilmadi.",
  support_error_action_not_allowed: "Bu amal hozir mavjud emas.",
  support_error_reopen_expired: "Murojaatni qayta ochish muddati o‘tgan — yangisini yarating.",
  support_error_order_not_exist: "Bunday raqam va email bilan buyurtma topilmadi.",
  support_error_email_send: "Xat yuborib bo‘lmadi. Keyinroq urinib ko‘ring.",
  support_error_too_many_requests: "Urinishlar juda ko‘p. Biroz kutib, qayta urinib ko‘ring.",
  support_error_unavailable: "Yordam xizmati vaqtincha ishlamayapti. Keyinroq urinib ko‘ring.",
  support_error_code_invalid: "Kod noto‘g‘ri yoki muddati o‘tgan.",
  support_error_access_required: "Kirishni tasdiqlash kerak: kabinetga kiring yoki buyurtma bo‘yicha kod so‘rang.",
};

const tj = {
  support_nav: "Дастгирӣ",
  support_title: "Муроҷиатҳои ман",
  support_subtitle: "Саволҳо оид ба фармоишҳо ва хизматрасонӣ — ҷавоб ба ин ҷо ва ба email меояд",
  support_footer_link: "Дастгирӣ",
  support_write: "Ба дастгирӣ навиштан",
  support_write_short: "Дастгирӣ",
  support_new_ticket: "Муроҷиати нав",
  support_filter_open: "Кушода",
  support_filter_all: "Ҳама",
  support_status_new: "Нав",
  support_status_in_progress: "Дар баррасӣ",
  support_status_waiting_customer: "Ҷавоби шуморо интизорем",
  support_status_closed: "Пӯшида",
  support_ticket_number: "Муроҷиати №{{number}}",
  support_unread_count: "Ҷавобҳои нав: {{count}}",
  support_no_tickets: "Ҳоло муроҷиат нест",
  support_no_open_tickets: "Муроҷиатҳои кушода нест",
  support_load_more: "Боз нишон додан",
  support_order: "Фармоиш",
  support_order_optional: "Фармоиш (ихтиёрӣ)",
  support_order_none: "Бе фармоиш — саволи умумӣ",
  support_order_manual: "Рақами фармоишро ворид кардан",
  support_order_number: "Рақами фармоиш",
  support_enter_order_number: "Масалан, 123456",
  support_subject: "Мавзӯъ",
  support_subject_placeholder: "Саволро мухтасар нависед",
  support_category: "Категория",
  support_category_choose: "Категорияро интихоб кунед",
  support_service_type: "Хизмат",
  support_service_avia: "Чиптаҳои ҳавопаймо",
  support_service_general: "Саволи умумӣ",
  support_service_hotel: "Меҳмонхонаҳо",
  support_category_refund: "Баргардонидан",
  support_category_exchange: "Иваз",
  support_category_passenger_data: "Маълумоти мусофирон",
  support_category_baggage: "Бағоҷ",
  support_category_seats: "Ҷойҳо дар ҳавопаймо",
  support_category_schedule_change: "Тағйири ҷадвал",
  support_category_payment: "Пардохт",
  support_category_documents: "Ҳуҷҷатҳо",
  support_category_account: "Кабинети шахсӣ",
  support_category_other: "Дигар",
  support_message: "Паём",
  support_message_placeholder: "Вазъиятро муфассал тавсиф кунед",
  support_reply_placeholder: "Ҷавоби шумо…",
  support_files_add: "Замима кардани файлҳо",
  support_files_hint: "То {{count}} файл, ҳар кадом то {{size}} МБ: {{ext}}",
  support_file_too_many: "Зиёда аз {{count}} файл замима кардан мумкин нест",
  support_file_too_large: "Файли «{{name}}» аз {{size}} МБ калон аст",
  support_file_bad_format: "Формати файли «{{name}}» дастгирӣ намешавад",
  support_text_too_long: "Матн хеле дароз аст: ҳадди аксар {{max}} аломат",
  support_remove: "Хориҷ кардан",
  support_send: "Фиристодан",
  support_create: "Эҷоди муроҷиат",
  support_cancel: "Бекор кардан",
  support_back_to_list: "Ҳамаи муроҷиатҳо",
  support_close: "Пӯшидани муроҷиат",
  support_reopen: "Аз нав кушодан",
  support_close_confirm: "Муроҷиат пӯшида шавад? Дар ҳолати зарурӣ онро аз нав кушодан мумкин аст.",
  support_closed_banner: "Муроҷиат пӯшида шуд. Агар масъала ҳал нашуда бошад — онро аз нав кушоед.",
  support_closed_banner_no_reopen: "Муроҷиат пӯшида шуд. Агар савол боқӣ монда бошад — муроҷиати нав эҷод кунед.",
  support_waiting_banner: "Дастгирӣ ҷавоби шуморо интизор аст",
  support_author_staff: "Дастгирӣ",
  support_author_you: "Шумо",
  support_event_created: "Муроҷиат эҷод шуд",
  support_event_status: "Ҳолат: {{from}} → {{to}}",
  support_created_at: "Эҷод шуд",
  support_updated_at: "Нав шуд",
  support_messages_count: "Паёмҳо: {{count}}",
  support_download: "Боргирӣ",
  support_login_required: "Барои кушодани муроҷиат ба кабинети шахсӣ ворид шавед",
  support_login: "Ворид шудан",
  support_access_title: "Фармоиши маро ёбед",
  support_access_subtitle: "Барои навиштан ба дастгирӣ бе воридшавӣ ба кабинет тасдиқ кунед, ки фармоиш аз они шумост.",
  support_access_hint: "Ҳангоми брон мо шуморо тавассути email ба қайд мегирем — код ба ҳамон ҷо меояд.",
  support_access_email: "Email-е, ки ҳангоми брон нишон дода шуд",
  support_access_send_code: "Гирифтани код",
  support_code_sent: "Мо мактуби дорои кодро ба {{email}} фиристодем",
  support_code_label: "Код аз мактуб",
  support_code_placeholder: "6 рақам",
  support_code_confirm: "Тасдиқ кардан",
  support_code_resend: "Кодро боз фиристодан",
  support_code_resend_in: "Пас аз {{seconds}} с боз фиристодан",
  support_change_order: "Фармоиши дигар",
  support_have_account: "Кабинети шахсӣ доред?",
  support_guest_order: "Муроҷиатҳо оид ба фармоиши {{order}}",
  support_guest_exit: "Баромадан",
  support_verifying: "Пайванд санҷида мешавад…",
  support_error_default: "Дархост иҷро нашуд. Боз кӯшиш кунед.",
  support_error_ticket_not_found: "Муроҷиат ёфт нашуд ё шумо ба он дастрасӣ надоред.",
  support_error_validation: "Дурустии пур кардани майдонҳоро санҷед.",
  support_error_validation_fields: "Санҷед: {{fields}}",
  support_error_ticket_closed: "Муроҷиат пӯшида аст — барои навиштан онро аз нав кушоед.",
  support_error_rate_limited: "Дархостҳо хеле зиёданд. Пас аз як дақиқа кӯшиш кунед.",
  support_error_file_invalid: "Файл қабул нашуд.",
  support_error_too_many_files: "Дар як паём файлҳо хеле зиёданд.",
  support_error_file_too_large: "Файл хеле калон аст.",
  support_error_file_format: "Ин формати файл дастгирӣ намешавад.",
  support_error_file_upload: "Боркунии файл муяссар нашуд. Боз кӯшиш кунед.",
  support_error_order_not_found: "Фармоиш ёфт нашуд.",
  support_error_action_not_allowed: "Ин амал ҳоло дастрас нест.",
  support_error_reopen_expired: "Мӯҳлати аз нав кушодани муроҷиат гузаштааст — муроҷиати нав эҷод кунед.",
  support_error_order_not_exist: "Фармоиш бо чунин рақам ва email ёфт нашуд.",
  support_error_email_send: "Фиристодани мактуб муяссар нашуд. Баъдтар кӯшиш кунед.",
  support_error_too_many_requests: "Кӯшишҳо хеле зиёданд. Каме интизор шуда, такрор кунед.",
  support_error_unavailable: "Дастгирӣ муваққатан дастрас нест. Баъдтар кӯшиш кунед.",
  support_error_code_invalid: "Код нодуруст аст ё мӯҳлаташ гузаштааст.",
  support_error_access_required: "Тасдиқи дастрасӣ лозим аст: ба кабинет ворид шавед ё барои фармоиш код дархост кунед.",
};

const kz = {
  support_nav: "Қолдау",
  support_title: "Менің өтінімдерім",
  support_subtitle: "Тапсырыстар мен қызмет бойынша сұрақтар — жауап осында және email-ге келеді",
  support_footer_link: "Қолдау қызметі",
  support_write: "Қолдау қызметіне жазу",
  support_write_short: "Қолдау",
  support_new_ticket: "Жаңа өтінім",
  support_filter_open: "Ашық",
  support_filter_all: "Барлығы",
  support_status_new: "Жаңа",
  support_status_in_progress: "Қаралуда",
  support_status_waiting_customer: "Жауабыңызды күтеміз",
  support_status_closed: "Жабылған",
  support_ticket_number: "Өтінім №{{number}}",
  support_unread_count: "Жаңа жауаптар: {{count}}",
  support_no_tickets: "Әзірге өтінімдер жоқ",
  support_no_open_tickets: "Ашық өтінімдер жоқ",
  support_load_more: "Тағы көрсету",
  support_order: "Тапсырыс",
  support_order_optional: "Тапсырыс (міндетті емес)",
  support_order_none: "Тапсырыссыз — жалпы сұрақ",
  support_order_manual: "Тапсырыс нөмірін енгізу",
  support_order_number: "Тапсырыс нөмірі",
  support_enter_order_number: "Мысалы, 123456",
  support_subject: "Тақырып",
  support_subject_placeholder: "Сұрағыңызды қысқаша жазыңыз",
  support_category: "Санат",
  support_category_choose: "Санатты таңдаңыз",
  support_service_type: "Қызмет",
  support_service_avia: "Әуе билеттері",
  support_service_general: "Жалпы сұрақ",
  support_service_hotel: "Қонақүйлер",
  support_category_refund: "Қайтару",
  support_category_exchange: "Айырбастау",
  support_category_passenger_data: "Жолаушы деректері",
  support_category_baggage: "Багаж",
  support_category_seats: "Ұшақтағы орындар",
  support_category_schedule_change: "Кесте өзгерісі",
  support_category_payment: "Төлем",
  support_category_documents: "Құжаттар",
  support_category_account: "Жеке кабинет",
  support_category_other: "Басқа",
  support_message: "Хабарлама",
  support_message_placeholder: "Жағдайды толық сипаттаңыз",
  support_reply_placeholder: "Сіздің жауабыңыз…",
  support_files_add: "Файл тіркеу",
  support_files_hint: "{{count}} файлға дейін, әрқайсысы {{size}} МБ-қа дейін: {{ext}}",
  support_file_too_many: "{{count}} файлдан артық тіркеуге болмайды",
  support_file_too_large: "«{{name}}» файлы {{size}} МБ-тан үлкен",
  support_file_bad_format: "«{{name}}» файлының пішімі қолдау көрсетілмейді",
  support_text_too_long: "Мәтін тым ұзын: ең көбі {{max}} таңба",
  support_remove: "Алып тастау",
  support_send: "Жіберу",
  support_create: "Өтінім жасау",
  support_cancel: "Болдырмау",
  support_back_to_list: "Барлық өтінімдер",
  support_close: "Өтінімді жабу",
  support_reopen: "Қайта ашу",
  support_close_confirm: "Өтінім жабылсын ба? Қажет болса, оны қайта ашуға болады.",
  support_closed_banner: "Өтінім жабылды. Мәселе шешілмесе — оны қайта ашыңыз.",
  support_closed_banner_no_reopen: "Өтінім жабылды. Сұрақтарыңыз қалса — жаңа өтінім жасаңыз.",
  support_waiting_banner: "Қолдау қызметі жауабыңызды күтуде",
  support_author_staff: "Қолдау қызметі",
  support_author_you: "Сіз",
  support_event_created: "Өтінім жасалды",
  support_event_status: "Мәртебе: {{from}} → {{to}}",
  support_created_at: "Жасалды",
  support_updated_at: "Жаңартылды",
  support_messages_count: "Хабарламалар: {{count}}",
  support_download: "Жүктеп алу",
  support_login_required: "Өтінімді ашу үшін жеке кабинетке кіріңіз",
  support_login: "Кіру",
  support_access_title: "Тапсырысымды табу",
  support_access_subtitle: "Кабинетке кірмей қолдау қызметіне жазу үшін тапсырыс сіздікі екенін растаңыз.",
  support_access_hint: "Брондау кезінде біз сізді email арқылы тіркейміз — код сол жерге келеді.",
  support_access_email: "Брондау кезінде көрсетілген email",
  support_access_send_code: "Кодты алу",
  support_code_sent: "Кодты хатты {{email}} мекенжайына жібердік",
  support_code_label: "Хаттағы код",
  support_code_placeholder: "6 сан",
  support_code_confirm: "Растау",
  support_code_resend: "Кодты қайта жіберу",
  support_code_resend_in: "{{seconds}} с кейін қайта жіберу",
  support_change_order: "Басқа тапсырыс",
  support_have_account: "Жеке кабинетіңіз бар ма?",
  support_guest_order: "{{order}} тапсырысы бойынша өтінімдер",
  support_guest_exit: "Шығу",
  support_verifying: "Сілтеме тексерілуде…",
  support_error_default: "Сұранысты орындау мүмкін болмады. Қайталап көріңіз.",
  support_error_ticket_not_found: "Өтінім табылмады немесе сізде оған қолжетімділік жоқ.",
  support_error_validation: "Өрістердің толтырылуын тексеріңіз.",
  support_error_validation_fields: "Тексеріңіз: {{fields}}",
  support_error_ticket_closed: "Өтінім жабық — жазу үшін оны қайта ашыңыз.",
  support_error_rate_limited: "Сұраныстар тым көп. Бір минуттан кейін көріңіз.",
  support_error_file_invalid: "Файл қабылданбады.",
  support_error_too_many_files: "Бір хабарламада файлдар тым көп.",
  support_error_file_too_large: "Файл тым үлкен.",
  support_error_file_format: "Бұл файл пішіміне қолдау көрсетілмейді.",
  support_error_file_upload: "Файлды жүктеу мүмкін болмады. Қайталап көріңіз.",
  support_error_order_not_found: "Тапсырыс табылмады.",
  support_error_action_not_allowed: "Бұл әрекет қазір қолжетімсіз.",
  support_error_reopen_expired: "Өтінімді қайта ашу мерзімі өтті — жаңасын жасаңыз.",
  support_error_order_not_exist: "Мұндай нөмір мен email-мен тапсырыс табылмады.",
  support_error_email_send: "Хат жіберу мүмкін болмады. Кейінірек көріңіз.",
  support_error_too_many_requests: "Әрекеттер тым көп. Біраз күтіп, қайталаңыз.",
  support_error_unavailable: "Қолдау қызметі уақытша қолжетімсіз. Кейінірек көріңіз.",
  support_error_code_invalid: "Код қате немесе мерзімі өткен.",
  support_error_access_required: "Қолжетімділікті растау қажет: кабинетке кіріңіз немесе тапсырыс бойынша код сұраңыз.",
};

const tm = {
  support_nav: "Goldaw",
  support_title: "Meniň ýüzlenmelerim",
  support_subtitle: "Sargytlar we hyzmat boýunça soraglar — jogap şu ýere we e-poçtaňyza geler",
  support_footer_link: "Goldaw gullugy",
  support_write: "Goldaw gullugyna ýazmak",
  support_write_short: "Goldaw",
  support_new_ticket: "Täze ýüzlenme",
  support_filter_open: "Açyk",
  support_filter_all: "Hemmesi",
  support_status_new: "Täze",
  support_status_in_progress: "Seredilýär",
  support_status_waiting_customer: "Jogabyňyza garaşýarys",
  support_status_closed: "Ýapyk",
  support_ticket_number: "Ýüzlenme №{{number}}",
  support_unread_count: "Täze jogaplar: {{count}}",
  support_no_tickets: "Häzirlikçe ýüzlenme ýok",
  support_no_open_tickets: "Açyk ýüzlenme ýok",
  support_load_more: "Ýene görkez",
  support_order: "Sargyt",
  support_order_optional: "Sargyt (hökmany däl)",
  support_order_none: "Sargytsyz — umumy sorag",
  support_order_manual: "Sargyt belgisini girizmek",
  support_order_number: "Sargyt belgisi",
  support_enter_order_number: "Mysal üçin, 123456",
  support_subject: "Tema",
  support_subject_placeholder: "Soragyňyzy gysgaça ýazyň",
  support_category: "Kategoriýa",
  support_category_choose: "Kategoriýany saýlaň",
  support_service_type: "Hyzmat",
  support_service_avia: "Awiabiletler",
  support_service_general: "Umumy sorag",
  support_service_hotel: "Myhmanhanalar",
  support_category_refund: "Yzyna gaýtarmak",
  support_category_exchange: "Çalyşmak",
  support_category_passenger_data: "Ýolagçy maglumatlary",
  support_category_baggage: "Goş",
  support_category_seats: "Uçardaky ýerler",
  support_category_schedule_change: "Tertibiň üýtgemegi",
  support_category_payment: "Töleg",
  support_category_documents: "Resminamalar",
  support_category_account: "Şahsy otag",
  support_category_other: "Başga",
  support_message: "Hat",
  support_message_placeholder: "Ýagdaýy jikme-jik beýan ediň",
  support_reply_placeholder: "Siziň jogabyňyz…",
  support_files_add: "Faýl goşmak",
  support_files_hint: "{{count}} faýla çenli, her biri {{size}} MB çenli: {{ext}}",
  support_file_too_many: "{{count}} faýldan köp goşup bolmaýar",
  support_file_too_large: "«{{name}}» faýly {{size}} MB-dan uly",
  support_file_bad_format: "«{{name}}» faýlynyň formaty goldanylmaýar",
  support_text_too_long: "Tekst gaty uzyn: iň köp {{max}} nyşan",
  support_remove: "Aýyrmak",
  support_send: "Ibermek",
  support_create: "Ýüzlenme döretmek",
  support_cancel: "Ýatyrmak",
  support_back_to_list: "Ähli ýüzlenmeler",
  support_close: "Ýüzlenmäni ýapmak",
  support_reopen: "Täzeden açmak",
  support_close_confirm: "Ýüzlenme ýapylsynmy? Gerek bolsa, ony täzeden açyp bolar.",
  support_closed_banner: "Ýüzlenme ýapyldy. Mesele çözülmedik bolsa, ony täzeden açyň.",
  support_closed_banner_no_reopen: "Ýüzlenme ýapyldy. Soraglaryňyz galan bolsa, täze ýüzlenme dörediň.",
  support_waiting_banner: "Goldaw gullugy jogabyňyza garaşýar",
  support_author_staff: "Goldaw gullugy",
  support_author_you: "Siz",
  support_event_created: "Ýüzlenme döredildi",
  support_event_status: "Ýagdaýy: {{from}} → {{to}}",
  support_created_at: "Döredildi",
  support_updated_at: "Täzelendi",
  support_messages_count: "Hatlar: {{count}}",
  support_download: "Ýükläp almak",
  support_login_required: "Ýüzlenmäni açmak üçin şahsy otaga giriň",
  support_login: "Girmek",
  support_access_title: "Sargydymy tapmak",
  support_access_subtitle: "Şahsy otaga girmezden goldaw gullugyna ýazmak üçin sargydyň siziňki bolandygyny tassyklaň.",
  support_access_hint: "Bronlanyňyzda biz sizi e-poçta boýunça hasaba alýarys — kod şol ýere geler.",
  support_access_email: "Bronlamakda görkezilen e-poçta",
  support_access_send_code: "Kod almak",
  support_code_sent: "Kodly haty {{email}} salgysyna iberdik",
  support_code_label: "Hatdaky kod",
  support_code_placeholder: "6 san",
  support_code_confirm: "Tassyklamak",
  support_code_resend: "Kody gaýtadan ibermek",
  support_code_resend_in: "{{seconds}} sek. soň gaýtadan ibermek",
  support_change_order: "Başga sargyt",
  support_have_account: "Şahsy otagyňyz barmy?",
  support_guest_order: "{{order}} sargydy boýunça ýüzlenmeler",
  support_guest_exit: "Çykmak",
  support_verifying: "Salgylanma barlanýar…",
  support_error_default: "Haýyşy ýerine ýetirip bolmady. Täzeden synanyşyň.",
  support_error_ticket_not_found: "Ýüzlenme tapylmady ýa-da oňa elýeterliligiňiz ýok.",
  support_error_validation: "Meýdançalaryň doldurylyşyny barlaň.",
  support_error_validation_fields: "Barlaň: {{fields}}",
  support_error_ticket_closed: "Ýüzlenme ýapyk — ýazmak üçin ony täzeden açyň.",
  support_error_rate_limited: "Haýyşlar gaty köp. Bir minutdan soň synanyşyň.",
  support_error_file_invalid: "Faýl kabul edilmedi.",
  support_error_too_many_files: "Bir hatda faýllar gaty köp.",
  support_error_file_too_large: "Faýl gaty uly.",
  support_error_file_format: "Bu faýl formaty goldanylmaýar.",
  support_error_file_upload: "Faýly ýükläp bolmady. Täzeden synanyşyň.",
  support_error_order_not_found: "Sargyt tapylmady.",
  support_error_action_not_allowed: "Bu hereket häzir elýeterli däl.",
  support_error_reopen_expired: "Ýüzlenmäni täzeden açmagyň möhleti geçdi — täzesini dörediň.",
  support_error_order_not_exist: "Şeýle belgili we e-poçtaly sargyt tapylmady.",
  support_error_email_send: "Haty iberip bolmady. Soňrak synanyşyň.",
  support_error_too_many_requests: "Synanyşyklar gaty köp. Biraz garaşyp, gaýtalaň.",
  support_error_unavailable: "Goldaw gullugy wagtlaýyn elýeterli däl. Soňrak synanyşyň.",
  support_error_code_invalid: "Kod nädogry ýa-da möhleti geçen.",
  support_error_access_required: "Elýeterliligi tassyklamak gerek: şahsy otaga giriň ýa-da sargyt boýunça kod soraň.",
};

export const supportTranslations = { ru, en, uz, tj, kz, tm };

/** Добавляет ключи заявок к ресурсам i18next (только к языкам сайта; свои ключи сайта не перезаписываются). */
export const withSupportTranslations = resources =>
  Object.fromEntries(
    Object.entries(resources).map(([language, bundle]) => [
      language,
      {
        ...bundle,
        translation: { ...(supportTranslations[language] || supportTranslations.en), ...(bundle?.translation || {}) },
      },
    ])
  );
